import React, { FC } from "react";
import Banner from "components/banner";
import { usePaginationStore } from "utils/usePaginationStore";
import TopBar from "components/tableComponents/topBar";
import { StaffMembersTable } from "components/tableComponents/staffMembersTable";
import SearchFilterField from "components/searchFilterField";
import { LocalizeText } from "components/localizer";
import CommunityFilterInput from "components/searchFilterComponents/communityFilter";

const StaffMembersView: FC = () => {
    const memberPagination = usePaginationStore("members", undefined, {
        page_size: 20,
        default_page_size: 20,
        search_by: "staff",
    });

    return (
        <div className="contentWrapper">
            <Banner
                title="members"
                subTitle="bannerStaffMembers"
                imageStyle={{ objectPosition: "72% 28%" }}
                image={`${process.env.PUBLIC_URL}/assets/images/arenaStaff/subscriptions.jpg`}
            />
            <TopBar
                searchField={
                    <SearchFilterField
                        pagination={memberPagination}
                        label={<LocalizeText tag="searchMembers" />}
                        filterFields={<CommunityFilterInput pagination={memberPagination} />}
                    />
                }
            />
            <StaffMembersTable pagination={memberPagination} />
        </div>
    );
};
export default StaffMembersView;
